module.exports = __webpack_public_path__ + "static/media/cell_logo.87226e4e.png";